/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconExposure0 = createReactComponent("exposure-0", "IconExposure0", [
  [
    "path",
    {
      d: "M12 19a4 4 0 0 0 4 -4v-6a4 4 0 1 0 -8 0v6a4 4 0 0 0 4 4z",
      key: "svg-0"
    }
  ]
]);

export { IconExposure0 as default };
//# sourceMappingURL=IconExposure0.js.map
